
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiArrowBidirectionalHorizontal as ObiArrowBidirectionalHorizontalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-arrow-bidirectional-horizontal.js';
 
 
 

 
 export const ObiArrowBidirectionalHorizontal = createComponent({
   react: React,
   tagName: 'obi-arrow-bidirectional-horizontal',
   elementClass: ObiArrowBidirectionalHorizontalElement,
   events: {
     
   }
  });
 
 